'use strict';

import {
    DOMUtils,
    HttpRequest,
    escapeHtml
} from "./Utils";
import {
    getAttr,
    resetAttr,
    setAttr
} from "./options";
import {
    btnBackListe
} from "./liste";

import {
    customAlert,
    customConfirm,
    closeDialogs,
    closeOneDialog,
    appendDialog,
    openDialogAdd,

    navBarClose,
    resetNavbar,

    abmelden,
    keyListnerLogin,
    setButtonEvent
} from "./dialog.js";
import {
    navButtonsHideAll
} from "./navButtons.js"
import {
    getCookie,
    setCookie,
    cookieEnum,
    removeCookie
} from "./cookie";

const home = {
    start() {
        startScreen();
    },

    close() {
        // stopScreen();
    }
};



window.$DOM = DOMUtils;


async function startScreen() {
    if (
        getAttr("user")) {
        window.location = "#liste";
        return;
    }

    navButtonsHideAll();
    $DOM("#btn-login").removeClass("hidden");
    initButtons();
    // fixBackButton();
}

function fixBackButton() {
    if (window.history && window.history.pushState) {
        // prevent first back
        window.history.pushState(null, "", window.location.href);

        $DOM(window).on("popstate",
            function (event) {
                if (closeDialogs()) {
                    // dialog got closed, stay on page
                    window.history.pushState(null, "", window.location.href);
                } else if (window.location.hash == "home") {
                    window.history.pushState(null, "", window.location.href);
                } else if (window.location.hash == "liste") {
                    btnBackListe();
                } else {
                    window.location.hash = "home";
                    window.history.pushState(null, "", window.location.href);
                }
            });
    }
}

function loginByToken() {
    new HttpRequest().send({
        url: "./php/api/user/login.php",
        type: "POST",
        data: {
            token: getCookie(cookieEnum.token)
        }
    }).done(function (e) {
        loginReqDone(e);
    }).fail(function (e) {
        resetAttr();
        if (window.location.hash !== "home") {
            window.location = "#home";
        }
        customAlert(e);
    });
}

function initButtons() {

    // those two buttons are placed in Main-content
    setButtonEvent("btnDemologin", demoLogin);
    setButtonEvent("btnMainLogin", loginBtn);
    // those two buttons are placed in Main-conten
}

function loginBtn() {
    closeDialogs();
    $DOM("#loginModal").dialog("open");
    $DOM("input").on("keyup", keyListnerLogin);
    openDialogAdd($DOM("#loginModal"));
    $DOM("#link-register").on("click", registerBtn);
    $DOM("#login-btnlogin").on("click", sendLogin);
    $DOM("#login-btnForgotPw").on("click", forgotPwBtn);
    $DOM("#login-btncancel").on("click",
        function () {
            closeDialogs();
        });
}


function forgotPwBtn() {
    closeDialogs();
    $DOM("#forgotPwModal").dialog("open");
    openDialogAdd($DOM("#forgotPwModal"));
    $DOM("#forgotPw-btnlogin").on("click", sendForgotPw);
    $DOM("#forgotPw-btncancel").on("click",
        function () {
            closeDialogs();
        });
}

function registerBtn() {
    closeDialogs();
    $DOM("#registerModal").dialog("open");
    appendDialog($DOM("#registerModal"));
    $DOM("#link-login").on("click", loginBtn);
    $DOM("#register-btnlogin").off();
    $DOM("#register-btnlogin").on("click", sendRegister);
    $DOM("#register-btncancel").on("click",
        function () {
            closeDialogs();
        });
}

function demoLogin() {
    new HttpRequest().send({
        url: "./php/api/user/login.php",
        type: "POST",
        data: {
            demologin: "true"
        }
    }).done(function (e) {
        closeDialogs();
        loginReqDone(e);
    }).fail(function (e) {
        customAlert(e);
    });
}


function sendLogin() {
    $DOM("#login-form-error").html("");
    if (!$DOM("#login-email").val() || $DOM("#login-email").getElm().validity.typeMismatch) {
        $DOM("#login-form-error").html("Bitte E-Mail angeben");
        return;
    } else if (!$DOM("#login-pw").val()) {
        $DOM("#login-form-error").html("Bitte Passwort angeben");
        return;
    }

    new HttpRequest().send({
        url: "./php/api/user/login.php",
        type: "POST",
        data: {
            email: $DOM("#login-email").val(),
            pw: $DOM("#login-pw").val()
        }
    }).done(function (e) {
        closeDialogs();
        loginReqDone(e);
    }).fail(function (e) {
        customAlert(e);
    });
}

function sendForgotPw() {
    if (!$DOM("#forgotPw-email").val() || $DOM("#forgotPw-email").getElm().validity.typeMismatch) {
        $DOM("#forgotPw-form-error").html("Bitte E-Mail angeben");
        return;
    } else if (!$DOM("#forgotPw-plz").val()) {
        $DOM("#forgotPw-form-error").html("Bitte Postleitzahl angeben");
        return;
    }
    new HttpRequest().send({
        url: "./php/api/user/forgotPw.php",
        type: "POST",
        data: {
            email: $DOM("#forgotPw-email").val(),
            plz: $DOM("#forgotPw-plz").val()
        }
    }).done(function (e) {
        closeDialogs();
        customAlert("Mail gesendet!");
    }).fail(function (e) {
        customAlert(e);
    });
}

function loginReqDone(e) {
    if (e.uid) {
        setAttr("user", e);
        if (e.verified == 0) {
            showVerifyModal();
            return;
        }
    }
    if (e.id) {
        setAttr("user", e);
        // valid for 30 days
        setCookie(cookieEnum.token, e.token, 30);

        if (window.location.hash !== "liste") {
            window.location = "#liste";
        }
    } else {
        customAlert("Fehler beim Anmelden");
        if (window.location.hash !== "home") {
            window.location = "#home";
        }
    }
}

function sendRegister() {
    $DOM("#register-form-error").html("");
    if (!$DOM("#register-email").val() || $DOM("#register-email").getElm().validity.typeMismatch) {
        $DOM("#register-form-error").html("Bitte E-Mail angeben");
        return;
    } else if (!$DOM("#register-name").val()) {
        $DOM("#register-form-error").html("Bitte Name angeben");
        return;
    } else if (!$DOM("#register-pw").val()) {
        $DOM("#register-form-error").html("Bitte Passwort angeben");
        return;
    } else if (!$DOM("#register-pw2").val()) {
        $DOM("#register-form-error").html("Bitte Passwort Wiederholung angeben");
        return;
    } else if ($DOM("#register-pw").val() != $DOM("#register-pw2").val()) {
        $DOM("#register-form-error").html("Passwörter stimmen nicht überein");
        return;
    }

    // new Admin user
    if (!$DOM("#org-name").val()) {
        $DOM("#register-form-error").html("Bitte Organisation angeben");
        return;
    } else if (!$DOM("#org-plz").val()) {
        $DOM("#register-form-error").html("Bitte Postleitzahl angeben");
        return;
    }
    new HttpRequest().send({
        url: "./php/api/user/create.php",
        type: "POST",
        data: {
            email: $DOM("#register-email").val(),
            pw: $DOM("#register-pw").val(),
            name: $DOM("#register-name").val(),
            orgName: $DOM("#org-name").val(),
            plz: $DOM("#org-plz").val()
        }
    }).done(function (e) {
        customAlert("OK - Bitte bestätige Mail!");
        closeDialogs();
        setAttr("user", e);
        showVerifyModal(e);
    }).fail(function (e) {
        customAlert(e);
    });
}


function resendVerifyMail(mail, uid) {
    customAlert("TODO: NOT IMPLEMENTED!!!");
}

function showVerifyModal() {
    var user = getAttr("user");
    var txt = " die angegebene E-Mail ";
    if (user.username) {
        txt = `<b>${escapeHtml(user.username)}</b>`;
    }

    closeDialogs();
    $DOM("#registerVerifyModal").dialog("open");
    appendDialog($DOM("#registerVerifyModal"));
    $DOM("#dialog-verify-mail").html(txt);

    $DOM("#verify-resend-btn").on("click", function () {
        resendVerifyMail(user.username, user.uid);
    });

    $DOM("#dialog-verify-btnok").on("click",
        function () {
            resetAttr();
            closeDialogs();
        });
}




export {
    home,
    loginByToken,
    loginBtn,
    sendLogin
}